import React, { useState, useEffect } from "react";
import "./UserToolbar.css";
import SearchIcon from "@mui/icons-material/Search";
import { AppButton } from "components/common/buttons";
import { AppTextField, AppSelect } from "components/common/inputs";
import { AppFilterBar } from "components/common/filters";

const UserToolbar = ({
  onSearch,
  onStatusChange,
  statusFilter = "Tất cả",
  initialSearchTerm = "",
  onAddUser,
}) => {
  const [searchInput, setSearchInput] = useState(initialSearchTerm);

  // Update searchInput when initialSearchTerm changes
  useEffect(() => {
    setSearchInput(initialSearchTerm);
  }, [initialSearchTerm]);

  const handleSearchChange = (value) => {
    setSearchInput(value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onSearch(searchInput);
  };
  return (
    <>
      {/* <div className="user-toolbar">
      <div className="toolbar-left">
        <div className="search-box">
          <form onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Tìm kiếm người dùng..."
              value={searchInput}
              onChange={handleSearchChange}
            />
            <button type="submit">
              <span className="material-icons">search</span>
            </button>
          </form>
        </div>{" "}
        <div className="filter-box">
          {" "}
          <select
            className="filter-button"
            onChange={(e) => {
              const selectedValue = e.target.value;
              onStatusChange(selectedValue);
            }}
            value={statusFilter}
          >
            <option value="Tất cả">Tất cả</option>
            <option value="Đã kích hoạt">Đã kích hoạt</option>
            <option value="Chưa kích hoạt">Chưa kích hoạt</option>
          </select>
        </div>
      </div>{" "}
      <div className="toolbar-right">
        <button className="add-user-btn" onClick={onAddUser}>
          <span className="material-icons">add</span>
          Thêm người dùng
        </button>
      </div>
    </div> */}

      <AppFilterBar icon={false}>
        <AppTextField
          placeholder="Tìm kiếm người dùng ..."
          value={searchInput}
          onChange={handleSearchChange}
          sx={{ flex: 1 }}
        />
        <AppSelect
          label="Trạng thái"
          value={statusFilter}
          options={[
            { value: "Tất cả", label: "Tất cả" },
            { value: "Đã kích hoạt", label: "Đã kích hoạt" },
            { value: "Chưa kích hoạt", label: "Chưa kích hoạt" },
          ]}
          onChange={(value) => {
            onStatusChange(value);
          }}
          sx={{ minWidth: 180, flex: 1 }}
        />
        <AppButton variant="outlined" onClick={handleSearchSubmit}>
          <SearchIcon />
        </AppButton>
        <AppButton
          variant="contained"
          color="primary"
          onClick={onAddUser}
          startIcon={<span className="material-icons">add</span>}
          disableElevation
        >
          Thêm người dùng
        </AppButton>
      </AppFilterBar >
    </>
  );
};

export default UserToolbar;
